import { request } from '@/utils/request'

/** 订阅授权准备结果 */
export interface WxSubscribePrepareVO {
  /** 订阅模式 1=订阅通知bizsend(开放标签) 2=一次性订阅(微信确认页，可跳H5) */
  mode: number
  /** 公众号AppID */
  appid: string
  /** 模板类型 match/appointment/remind */
  templateType: string
  /** 微信模板ID */
  templateId: string
  /** 模式2：微信官方确认页地址（整页跳转） */
  confirmUrl?: string
}

/** wx.config 签名结果（含 wx-open-subscribe 开放标签） */
export interface WxNotifyJsConfigVO {
  appId: string
  timestamp: number
  nonceStr: string
  signature: string
  jsApiList: string[]
  openTagList: string[]
}

/**
 * 用微信回调下发的一次性交换码绑定当前登录用户（含游客期待补记额度）
 * POST /wx-notify/bind
 */
export function bindWxOpenid(wxoid: string) {
  return request.post('/wx-notify/bind', { wxoid })
}

/**
 * 订阅授权成功额度上报（模式1 wx-open-subscribe success 回调）
 * POST /wx-notify/quota/grant
 */
export function grantSubscribeQuota(acceptedTemplateIds: string[]) {
  return request.post('/wx-notify/quota/grant', { acceptedTemplateIds })
}

/**
 * 订阅授权准备：模式1返回模板信息，模式2返回微信确认页地址
 * GET /wx-notify/subscribe/prepare
 */
export function prepareSubscribe(templateType: string, redirect: string) {
  return request.get<WxSubscribePrepareVO>('/wx-notify/subscribe/prepare', {
    type: templateType,
    redirect
  })
}

/**
 * 多租户公众号 wx.config 签名（含 wx-open-subscribe 开放标签）
 * GET /wx-notify/jsconfig
 */
export function getWxNotifyJsConfig(url: string, wxappid?: string) {
  return request.getSilent<WxNotifyJsConfigVO>('/wx-notify/jsconfig', {
    url,
    ...(wxappid ? { wxappid } : {})
  })
}
